const state = {
  scheduleDemoModal: {
    show: false,
    contact: null,
  },
  setReminderModal: {
    show: false,
    contact: null,
  },
};

const getters = {
  getScheduleDemoModal: $state => $state.scheduleDemoModal,
  getSetReminderModal: $state => $state.setReminderModal,
};

const mutations = {
  SHOW_SCHEDULE_DEMO_MODAL($state, contact) {
    $state.scheduleDemoModal = {
      show: true,
      contact,
    };
    // Hide reminder modal when showing demo modal
    $state.setReminderModal = {
      show: false,
      contact: null,
    };
  },
  HIDE_SCHEDULE_DEMO_MODAL($state) {
    $state.scheduleDemoModal = {
      show: false,
      contact: null,
    };
  },
  SHOW_SET_REMINDER_MODAL($state, contact) {
    $state.setReminderModal = {
      show: true,
      contact,
    };
    // Hide demo modal when showing reminder modal
    $state.scheduleDemoModal = {
      show: false,
      contact: null,
    };
  },
  HIDE_SET_REMINDER_MODAL($state) {
    $state.setReminderModal = {
      show: false,
      contact: null,
    };
  },
};

const actions = {
  showScheduleDemoModal({ commit }, contact) {
    commit('SHOW_SCHEDULE_DEMO_MODAL', contact);
  },
  hideScheduleDemoModal({ commit }) {
    commit('HIDE_SCHEDULE_DEMO_MODAL');
  },
  showSetReminderModal({ commit }, contact) {
    commit('SHOW_SET_REMINDER_MODAL', contact);
  },
  hideSetReminderModal({ commit }) {
    commit('HIDE_SET_REMINDER_MODAL');
  },
  switchToReminder({ commit, state: $state }) {
    const contact = $state.scheduleDemoModal.contact;
    commit('HIDE_SCHEDULE_DEMO_MODAL');
    if (contact) {
      commit('SHOW_SET_REMINDER_MODAL', contact);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
